<template>
    <div class="semaforo-verde">
        <div class="check"></div>
    </div>
</template>

<script>
export default {
    name: 'SemaforoVerde',
}
</script>

<style scoped>
.semaforo-verde {
    border-radius: 20px;
    background-color: #5d9165;
    width: 26px;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.semaforo-verde .check {
    display: inline-block;
    transform: rotate(45deg);
    height: 14px;
    width: 7px;
    border-bottom: 3px solid #fff;
    border-right: 3px solid #fff;
    margin-bottom: 5px;
}
</style>